<script setup>
  // 로그인 후 메인에서 띄우는 대상 지정 설문 참여 안내 팝업
  // - 관리자(포털 관리 > 설문 관리)가 대상자로 등록한 교사에게만 노출
  // - [오늘 하루 보지 않기] : 오늘 날짜를 브라우저에 기록해 같은 날 다시 띄우지 않는다
  import { computed } from "vue";

  const props = defineProps({
    show: { type: Boolean, required: true },
    surveys: { type: Array, default: () => [] },
  });
  const emits = defineEmits(["update:show", "join", "hide-today"]);

  const localShow = computed({
    get: () => props.show,
    set: (val) => emits("update:show", val),
  });

  const closeModal = () => {
    localShow.value = false;
  };
</script>

<template>
  <ui-modal
    v-model:show="localShow"
    size="xm"
    :title="''"
    :close-on-esc="false"
    :closable="false"
    class="survey-popup-modal"
  >
    <template #body>
      <div class="survey-popup">
        <svg class="survey-popup-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6">
          <rect x="5" y="4" width="14" height="17" rx="2" />
          <path d="M9 4.5V3.5A1.5 1.5 0 0 1 10.5 2h3A1.5 1.5 0 0 1 15 3.5v1" />
          <path d="m9.5 13.2 1.8 1.8 3.4-3.6" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
        <p class="survey-popup-title">설문조사 참여 안내</p>
        <p class="survey-popup-text">선생님께 참여를 요청드리는 설문이 있습니다.</p>

        <ul class="survey-popup-list">
          <li v-for="survey in surveys" :key="survey.survey_id" class="survey-popup-item">
            <div class="survey-popup-info">
              <p class="survey-popup-name">{{ survey.survey_name }}</p>
              <p class="survey-popup-period">
                참여 기간 {{ survey.start_date }} ~ {{ survey.end_date }}
                <span v-if="survey.in_progress_yn === 'Y'" class="survey-popup-badge">이어서 참여</span>
              </p>
            </div>
            <ui-button class="survey-popup-join" @click="emits('join', survey)">참여하기</ui-button>
          </li>
        </ul>
      </div>
    </template>
    <template #footer>
      <div class="survey-popup-footer">
        <button type="button" class="survey-popup-hide" @click="emits('hide-today')">
          오늘 하루 보지 않기
        </button>
        <ui-button variant="outlined" color="gray" @click="closeModal">닫기</ui-button>
      </div>
    </template>
  </ui-modal>
</template>

<style lang="scss" scoped>
  .survey-popup {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 12px;
    text-align: center;
  }

  .survey-popup-icon {
    width: 3rem;
    height: 3rem;
    color: #3b6ef5;
  }

  .survey-popup-title {
    margin-top: 0.75rem;
    font-size: 1.15rem;
    font-weight: 800;
    color: #111827;
  }

  .survey-popup-text {
    margin-top: 0.4rem;
    font-size: 0.9rem;
    color: #6b7280;
  }

  .survey-popup-list {
    width: 100%;
    margin-top: 1.25rem;
    display: flex;
    flex-direction: column;
    gap: 0.6rem;
  }

  .survey-popup-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0.75rem;
    padding: 0.85rem 1rem;
    border: 1px solid #e2e8f4;
    border-radius: 0.5rem;
    background: #f8faff;
    text-align: left;
  }

  .survey-popup-info {
    min-width: 0;
  }

  .survey-popup-name {
    font-size: 0.95rem;
    font-weight: 700;
    color: #111827;
    word-break: keep-all;
  }

  .survey-popup-period {
    margin-top: 0.2rem;
    font-size: 0.8rem;
    color: #6b7280;
  }

  .survey-popup-badge {
    margin-left: 0.4rem;
    padding: 0.1rem 0.45rem;
    border-radius: 999px;
    background: #e9f9f0;
    color: #14a45c;
    font-size: 0.72rem;
    font-weight: 700;
  }

  .survey-popup-join {
    flex: 0 0 auto;
    white-space: nowrap;
  }

  .survey-popup-footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
  }

  .survey-popup-hide {
    border: none;
    background: none;
    padding: 0;
    font-size: 0.85rem;
    color: #6b7280;
    text-decoration: underline;
    cursor: pointer;
  }
</style>
